import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, DemoContent} from '@fuse';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../../../auth/store/actions';
import {
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import { Grid, Table, TableHeaderRow, TableFilterRow } from '@devexpress/dx-react-grid-material-ui';

const styles = theme => ({
    layoutRoot: {}
});

class Example extends Component {
    state = {
        qr:''
    };

    render()
    {
        const {classes} = this.props;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Header</h4></div>
                }
                contentToolbar={
                    <div className="px-24"><h4>Content Toolbar</h4></div>
                }
                content={
                    <div className="p-24">
                        <h4>Content</h4>
                        <br/>
                      {(this.props.user.role.includes('admin')) &&
                        <DemoContent/>
                      }
                        <Grid
                          rows={[
                              { id: 0, product: 'DevExtreme', owner: 'DevExpress' },
                              { id: 1, product: 'DevExtreme Reactive', owner: 'DevExpress' },
                          ]}
                          columns={[
                              { name: 'id', title: 'ID' },
                              { name: 'product', title: 'Product' },
                              { name: 'owner', title: 'Owner' },
                          ]}>
                            <FilteringState defaultFilters={[]} />
                            <IntegratedFiltering />
                            <Table />
                            <TableHeaderRow />
                            <TableFilterRow />
                        </Grid>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        setUserData: Actions.setUserData,
        setUserDataFromDB: Actions.setUserDataFromDB,
    }, dispatch);
}

function mapStateToProps({fuse, auth})
{
    return {
        login   : auth.login,
        user    : auth.user
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps,mapDispatchToProps)(Example));
